import { createSelector } from "reselect";
import { surveyWoundDetailsSelector } from "../survey_wound_details_selector";

export const surveyWoundDetailsLoadStateSelector = createSelector(
  surveyWoundDetailsSelector,
  woundDetails => woundDetails.loadState
);
